export default "__VITE_ASSET__i64PR4os__"